import cx from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { ArrowLink, Button, GridBleed, Modal } from '@bwoty-web/ui-kit';

import './priceSummary.scss';

const PriceSummary = ({
  labels,
  productAndPaxInfo,
  totalPrice,
  priceDetails,
  loading,
  discounted,
  onNavigate,
  disclaimer,
}) => {
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const isGlobetrotter = useIsGlobetrotter();
  const WrapperElement = isGlobetrotter ? GridBleed : 'div';

  return (
    <WrapperElement
      className='iw-price-summary'
    >
      <div className="iw-price-summary__top">
        <div className="iw-price-summary__header">
          <span className="iw-price-summary__price-label">
            {labels.totalPrice}
          </span>
          <span
            className={cx('iw-price-summary__price', {
              'iw-price-summary__price--discounted': discounted,
            })}
          >
            {totalPrice}
          </span>
        </div>
        {productAndPaxInfo && (
          <div className="iw-price-summary__products-included">
            {productAndPaxInfo}
          </div>
        )}
        <Button
          variant="primary"
          className="iw-price-summary__button"
          loading={loading}
          disabled={loading}
          onClick={() => onNavigate()}
        >
          {labels.button}
        </Button>
        {priceDetails && labels.priceDetails && (
          <div className="iw-price-summary__expand-price-container">
            <ArrowLink
              aria-haspopup="dialog"
              data-gtm-tag="Price Details"
              onClick={() => setShowPriceDetails(true)}
            >
              {labels.priceDetails}
            </ArrowLink>
          </div>
        )}
      </div>
      <Modal
        heading={labels.priceDetails}
        isOpen={priceDetails && showPriceDetails}
        onClose={() => setShowPriceDetails(false)}
      >
        <div className="iw-price-summary__price-details-container">
          {priceDetails}
        </div>
      </Modal>
      {disclaimer && (
        <div
          className={cx('iw-price-summary__disclaimer', {
            'iw-price-summary__disclaimer--no-margin': showPriceDetails,
          })}
        >
          {disclaimer}
        </div>
      )}
    </WrapperElement>
  );
};

PriceSummary.propTypes = {
  disclaimer: PropTypes.string,
  discounted: PropTypes.bool,
  labels: PropTypes.shape({
    button: PropTypes.string,
    priceDetails: PropTypes.string,
    totalPrice: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
  priceDetails: PropTypes.node,
  productAndPaxInfo: PropTypes.string,
  totalPrice: PropTypes.string.isRequired,
};

PriceSummary.defaultProps = {
  disclaimer: null,
  discounted: false,
  loading: false,
  priceDetails: null,
  productAndPaxInfo: null,
};

export default PriceSummary;
